(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9049],{

/***/ 30550:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/email/mail",
      function () {
        return __webpack_require__(17664);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 11883:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(57135);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(59072);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(80677);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50959);
/* harmony import */ var components_FormElements_SimpleTextBox__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53909);
/* harmony import */ var components_FormElements_SimpleTextArea__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88234);
/* harmony import */ var components_FormElements_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62303);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66264);
/* harmony import */ var _FormElements_PhoneSelectBox__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(75967);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2218);
/* harmony import */ var services_allServices__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(63700);
/* harmony import */ var _PrivacyPolicy__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(14956);
/* harmony import */ var _Toast_AllToast__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(86749);














function DidntFindForm(param) {
    var iys = param.iys, eposta = param.eposta;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_5__/* .useTranslation */ .$G)([
        "common",
        "iys",
        "email"
    ]).t;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,hooks__WEBPACK_IMPORTED_MODULE_7__/* .useConfigureSelectBoxItem */ .HU)(), 2), phoneList = ref[0], setPhoneList = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), selectedPhone = ref1[0], setSelectedPhone = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isPrivacyPolicy = ref2[0], setIsPrivacyPolicy = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), name = ref3[0], setName = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), phone = ref4[0], setPhone = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), email = ref5[0], setEmail = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), contents = ref6[0], setContents = ref6[1];
    var onSendMail = function() {
        if (!isPrivacyPolicy) {
            return (0,_Toast_AllToast__WEBPACK_IMPORTED_MODULE_10__/* .alertToast */ .qC)(t("common:error"), t("common:privacyPolicyError"));
        }
        if (name === "" || phone === "" || email === "" || contents === "") {
            return (0,_Toast_AllToast__WEBPACK_IMPORTED_MODULE_10__/* .alertToast */ .qC)(t("common:error"), t("common:fillAllFieldsError"));
        }
        var configure = {
            form_name: "Sunucu İstek Formu",
            name: name,
            phone: phone,
            email: email,
            subject: "",
            contents: contents
        };
        (0,services_allServices__WEBPACK_IMPORTED_MODULE_8__/* .sendMail */ .Yb)(configure).then(function(res) {
            if (res.status === "submitted") {
                (0,_Toast_AllToast__WEBPACK_IMPORTED_MODULE_10__/* .successToast */ .Qm)(t("common:success"), t("common:mailSendSuccess"));
                setName("");
                setPhone("");
                setEmail("");
                setSubject("");
                setContents("");
            }
        });
    };
    var onGetCountry = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(function() {
            var countries;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_13__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        countries = [];
                        return [
                            4,
                            (0,services_allServices__WEBPACK_IMPORTED_MODULE_8__/* .getCountry */ .rZ)()
                        ];
                    case 1:
                        countries = _state.sent();
                        setPhoneList(countries, "phone_code", "country_name");
                        return [
                            2
                        ];
                }
            });
        });
        return function onGetCountry() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        phoneList.map(function(item) {
            if (item.id === "90") {
                setSelectedPhone(item);
            }
        });
    }, [
        phoneList
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        onGetCountry();
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "w-full bg-didntFindBg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "container px-4 mx-auto lg:px-0",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "grid grid-cols-2 my-20",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex items-center justify-center col-span-2 lg:col-span-1 ",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "",
                            children: [
                                !eposta && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "mb-2 text-2xl text-selectboxText",
                                    children: iys ? t("iys:didntFindFormTitleIYS") : t("common:didntFindFormTitle")
                                }),
                                !eposta && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "relative mb-8 text-4xl font-semibold text-after-shadow lg:text-5xl",
                                    children: iys ? t("iys:didntFindFormTitle2IYS") : t("common:didntFindFormTitle2")
                                }),
                                eposta && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "relative mb-8 text-4xl font-semibold text-after-shadow lg:text-5xl",
                                    children: t("email:emailFormTitle")
                                }),
                                !eposta && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "mt-5 text-md text-selectboxText lg:pr-48",
                                    children: iys ? t("iys:didntFindFormDescriptionIYS") : t("common:didntFindFormDescription")
                                }),
                                eposta && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "mt-5 text-md text-selectboxText lg:pr-48",
                                    children: t("email:emailFormDesc")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex justify-center col-span-2 mt-10 lg:col-span-1 lg:mt-0",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "p-10 bg-white rounded-md shadow-lg lg:w-10/12",
                            children: [
                                !eposta && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                    className: "mb-5 text-2xl font-medium text-selectboxText",
                                    children: iys ? t("iys:iysRequestForm") : t("common:serverRequestForm")
                                }),
                                eposta && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                    className: "mb-5 text-2xl font-medium text-selectboxText",
                                    children: t("email:emailFormTitle2")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "mb-3",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_FormElements_SimpleTextBox__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                        value: name,
                                        onChange: setName,
                                        labelName: t("common:nameSurname"),
                                        inputName: "name",
                                        placeholder: t("common:nameSurname")
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "mb-3",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_FormElements_SimpleTextBox__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                        value: email,
                                        onChange: setEmail,
                                        labelName: t("common:emailAddress"),
                                        inputName: "eMail",
                                        placeholder: "info@makdos.com"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex items-center w-full lg:mb-3",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            children: selectedPhone && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FormElements_PhoneSelectBox__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                data: phoneList,
                                                selectedItem: selectedPhone,
                                                setSelectedItem: function(v) {
                                                    return setSelectedPhone(v);
                                                },
                                                labelName: t("common:code")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "-mt-3 lg:mt-0.5 w-full relative",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_FormElements_SimpleTextBox__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                                value: phone,
                                                onChange: function(v) {
                                                    setPhone(v === null || v === void 0 ? void 0 : v.replaceAll(/\D/g, ""));
                                                },
                                                labelName: t("common:phoneNumber"),
                                                inputName: "phone",
                                                placeholder: "8503077744"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "mb-3",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_FormElements_SimpleTextArea__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                        value: contents,
                                        onChange: setContents,
                                        labelName: t("common:yourMessage"),
                                        inputName: "message",
                                        rows: "4",
                                        placeholder: t("common:didntFindFormPlaceholder")
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "items-center justify-between mt-5 lg:flex",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivacyPolicy__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                            isPrivacyPolicy: isPrivacyPolicy,
                                            setIsPrivacyPolicy: setIsPrivacyPolicy
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "lg:w-[350px]",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_FormElements_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                onClick: onSendMail,
                                                name: "didntFind",
                                                buttonText: t("common:requestAQuote"),
                                                buttonRightIcon: "ri-arrow-right-line"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (DidntFindForm);


/***/ }),

/***/ 14313:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59072);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50959);
/* harmony import */ var _SSSAccordion__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2097);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66264);





function SSS(param) {
    var data = param.data;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)([
        "common",
        "nav"
    ]).t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "container px-4 mx-auto bg-white lg:px-0",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "my-5 lg:my-10",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "relative z-30 text-4xl font-semibold text-after-shadow lg:text-5xl",
                    children: t("frequentlyAskedQuestions")
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "grid grid-cols-2 mt-10 lg:gap-x-8",
                    children: data && Object.entries(data).map(function(param) {
                        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(param, 2), key = _param[0], value = _param[1];
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SSSAccordion__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            title: key,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                dangerouslySetInnerHTML: {
                                    __html: value
                                }
                            })
                        }, key);
                    })
                })
            ]
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (SSS);


/***/ }),

/***/ 2097:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50959);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2218);



function SSSAccordion(param) {
    var title = param.title, children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), open = ref[0], setOpen = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "faqAccordionColspan",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-full p-3 border-2 ".concat(open ? "rounded-b-none border-b" : "rounded-md"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    onClick: function() {
                        return setOpen(!open);
                    },
                    className: "faqTitleStyle",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "font-semibold text-md",
                            children: title
                        }),
                        !open ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                            className: "text-xl font-semibold ri-add-line"
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                            className: "text-xl font-semibold ri-subtract-line"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "faqChildrenStyle ".concat(open ? "block" : "hidden", " "),
                children: children
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (SSSAccordion);


/***/ }),

/***/ 17664:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ mail; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(59072);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(11527);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_react-dom@18.2.0_react@18.2.0/node_modules/next/head.js
var head = __webpack_require__(93834);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./layout/Layout/index.js + 9 modules
var Layout = __webpack_require__(4967);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_react-dom@18.2.0_react@18.2.0/node_modules/next/image.js
var next_image = __webpack_require__(70649);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/SSS/SSS.js
var SSS = __webpack_require__(14313);
// EXTERNAL MODULE: ./node_modules/.pnpm/next-i18next@13.0.2_i18next@22.4.6_next@12.3.4_react-i18next@12.1.1_react@18.2.0/node_modules/next-i18next/dist/esm/index.js + 11 modules
var esm = __webpack_require__(66264);
;// CONCATENATED MODULE: ./components/CorporateEmail/EmailServices.js




function EmailServices() {
    var t = (0,esm/* useTranslation */.$G)([
        "common",
        "homepage",
        "email"
    ]).t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative p-5 services bg-makdosSecondaryGray lg:p-28",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute 2xl:left-72 2xl:top-12 lg:left-12 lg:top-14 z-1",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: "/mask.png",
                    alt: "mask",
                    title: "email",
                    width: 184,
                    height: 184
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute 2xl:right-72 2xl:bottom-20 lg:right-14 lg:bottom-24 z-1",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: "/mask.png",
                    alt: "mask",
                    title: "email",
                    width: 184,
                    height: 184
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container grid grid-cols-4 gap-10 mx-auto mb-10 ",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "z-10 col-span-4 transition-all duration-500 bg-white border-b-4 border-transparent rounded-md shadow-lg cursor-pointer servicesCard group lg:col-span-1 hover:border-makdosYellow hover:border-b-4 hover:shadow-2xl",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "p-10 pb-10 rounded-sm servicesCardContent",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "relative w-12 h-12 rounded-full bg-makdosYellow",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "absolute text-5xl top-3 -right-3 ri-shield-check-line"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "mt-5 mb-4 text-lg font-semibold",
                                    children: t("email:servicesBoxTitle1")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-sm text-cardText",
                                    dangerouslySetInnerHTML: {
                                        __html: t("email:servicesBoxDescription1")
                                    }
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-span-4 transition-all duration-500 bg-white border-b-4 border-transparent rounded-md shadow-lg cursor-pointer servicesCard group lg:col-span-1 hover:border-makdosYellow hover:border-b-4 hover:shadow-2xl",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "p-10 pb-10 rounded-sm servicesCardContent",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "relative w-12 h-12 rounded-full bg-makdosYellow",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "absolute text-5xl top-3 -right-3 ri-hard-drive-line"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "mt-5 mb-4 text-lg font-semibold",
                                    children: t("email:servicesBoxTitle2")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-sm text-cardText",
                                    dangerouslySetInnerHTML: {
                                        __html: t("email:servicesBoxDescription2")
                                    }
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-span-4 transition-all duration-500 bg-white border-b-4 border-transparent rounded-md shadow-lg cursor-pointer servicesCard group lg:col-span-1 hover:border-makdosYellow hover:border-b-4 hover:shadow-2xl",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "p-10 pb-10 rounded-sm servicesCardContent",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "relative w-12 h-12 rounded-full bg-makdosYellow",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "absolute text-5xl top-3 -right-3 ri-device-line"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "mt-5 mb-4 text-lg font-semibold",
                                    children: t("email:servicesBoxTitle3")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-sm text-cardText",
                                    dangerouslySetInnerHTML: {
                                        __html: t("email:servicesBoxDescription3")
                                    }
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-span-4 transition-all duration-500 bg-white border-b-4 border-transparent rounded-md shadow-lg cursor-pointer servicesCard group lg:col-span-1 hover:border-makdosYellow hover:border-b-4 hover:shadow-2xl",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "p-10 pb-10 rounded-sm servicesCardContent",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "relative w-12 h-12 rounded-full bg-makdosYellow",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "absolute text-5xl top-3 -right-3 ri-customer-service-2-line"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "mt-5 mb-4 text-lg font-semibold",
                                    children: t("email:servicesBoxTitle4")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-sm text-cardText",
                                    children: t("email:servicesBoxDescription4")
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container grid grid-cols-4 gap-10 mx-auto mb-10",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-span-4 transition-all duration-500 bg-white border-b-4 border-transparent rounded-md shadow-lg cursor-pointer servicesCard group lg:col-span-1 hover:border-makdosYellow hover:border-b-4 hover:shadow-2xl",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "p-10 pb-10 rounded-sm servicesCardContent",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "relative w-12 h-12 rounded-full bg-makdosYellow",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "absolute text-5xl top-3 -right-3 ri-mail-forbid-line"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "mt-5 mb-4 text-lg font-semibold",
                                    children: t("email:servicesBoxTitle5")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-sm text-cardText",
                                    dangerouslySetInnerHTML: {
                                        __html: t("email:servicesBoxDescription5")
                                    }
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-span-4 transition-all duration-500 bg-white border-b-4 border-transparent rounded-md shadow-lg cursor-pointer servicesCard group lg:col-span-1 hover:border-makdosYellow hover:border-b-4 hover:shadow-2xl",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "p-10 pb-10 rounded-sm servicesCardContent",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "relative w-12 h-12 rounded-full bg-makdosYellow",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "absolute text-5xl top-3 -right-3 ri-history-line"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "mt-5 mb-4 text-lg font-semibold",
                                    children: t("email:servicesBoxTitle6")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-sm text-cardText",
                                    dangerouslySetInnerHTML: {
                                        __html: t("email:servicesBoxDescription6")
                                    }
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-span-4 transition-all duration-500 bg-white border-b-4 border-transparent rounded-md shadow-lg cursor-pointer servicesCard group lg:col-span-1 hover:border-makdosYellow hover:border-b-4 hover:shadow-2xl",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "p-10 pb-10 rounded-sm servicesCardContent",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "relative w-12 h-12 rounded-full bg-makdosYellow",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "absolute text-5xl top-3 -right-3 ri-mail-unread-line"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "mt-5 mb-4 text-lg font-semibold",
                                    children: t("email:servicesBoxTitle7")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-sm text-cardText",
                                    dangerouslySetInnerHTML: {
                                        __html: t("email:servicesBoxDescription7")
                                    }
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "z-10 col-span-4 transition-all duration-500 bg-white border-b-4 border-transparent rounded-md shadow-lg cursor-pointer servicesCard group lg:col-span-1 hover:border-makdosYellow hover:border-b-4 hover:shadow-2xl",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "p-10 pb-10 rounded-sm servicesCardContent",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "relative w-12 h-12 rounded-full bg-makdosYellow",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "absolute text-5xl top-3 -right-3 ri-bar-chart-box-line"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "mt-5 mb-4 text-lg font-semibold",
                                    children: t("email:servicesBoxTitle8")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-sm text-cardText",
                                    dangerouslySetInnerHTML: {
                                        __html: t("email:servicesBoxDescription8")
                                    }
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var CorporateEmail_EmailServices = (EmailServices);

// EXTERNAL MODULE: ./store/GlobalStore.js
var GlobalStore = __webpack_require__(36345);
// EXTERNAL MODULE: ./helpers/helpersFunc.js + 2 modules
var helpersFunc = __webpack_require__(65126);
// EXTERNAL MODULE: ./components/FormElements/Button.js
var Button = __webpack_require__(62303);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_react-dom@18.2.0_react@18.2.0/node_modules/next/router.js
var next_router = __webpack_require__(63498);
// EXTERNAL MODULE: ./store/ConfigurationStore.js
var ConfigurationStore = __webpack_require__(20363);
;// CONCATENATED MODULE: ./public/SSS/sss-tr-kurumsal-eposta.json
var sss_tr_kurumsal_eposta_namespaceObject = JSON.parse('{"E-Posta hesabımı hangi cihazlarda kullanabilirim?":"<b>Kurumsal e-posta</b> hesabınızı bilgisayar, akıllı telefon ve tablet gibi tüm cihazlarda kullanabilirsiniz.","E-Posta hesabımın kullanıcı adı ve şifresini nasıl değiştirebilirim?":"Müşteri panelinden e-posta hesabınıza girerek, kullanıcı adı ve şifrenizi değiştirebilirsiniz.","Toplu e-posta gönderimi yapabilir miyim?":"Evet, toplu e-posta gönderimi yaparak, işletmenizin haberlerini, kampanyalarını ve duyurularını müşterilerinize ulaştırabilirsiniz. Ancak bu, toplu mail saatlik gönderim limitinizi de aşmamalıdır.","Mobil cihazlardan kurumsal e-postaları nasıl kullanabilirim?":"<b>Kurumsal e-posta</b> hizmetimiz, tüm popüler mobil cihazlarla uyumludur. Android ve iOS cihazlar için e-posta ayarlarınızı yapılandırarak, mobil cihazınızdan e-postalarınıza erişebilir ve yönetebilirsiniz.","Makdos Kurumsal E-Posta ile bireysel e-posta hizmetleri arasındaki fark nedir?":"Bireysel e-posta hizmetleri (Gmail, Yandex Mail gibi) kişisel kullanım için idealdir. Ancak, Makdos Kurumsal <b>Mail Hosting</b>, işletmelere özel alan adı, gelişmiş güvenlik, günlük yedekleme ve özelleştirilebilir özellikler sunar.","Kurumsal e-posta hizmetinde spam koruması var mı?":"Evet, Makdos <b>Mail Hosting</b> gelişmiş spam filtreleme teknolojisi ile e-postalarınızı istenmeyen maillerden korur.","Kurumsal e-posta adresimi nasıl alabilirim?":"Makdos üzerinden birkaç kolay adımla alan adınıza özel <b>kurumsal e-posta</b> adresinizi oluşturabilirsiniz. Makdos Mail hizmetinde \'Yapılandır\' butonuna tıklayarak e-posta adresi alabilirsiniz.","E-postalarımı başka bir adrese yönlendirebilir miyim?":"Evet, Makdos Mail Yönetim Paneli sayesinde gelen e-postalarınızı başka bir e-posta adresine kolayca yönlendirebilirsiniz.","Makdos Mail Hosting hangi protokolleri destekliyor?":"Makdos, IMAP, SMTP ve POP3 protokollerini destekleyerek tüm cihazlardan e-posta erişimini kolaylaştırır.","Makdos Mail Hosting’de günlük yedekleme var mı?":"Evet, Makdos tüm e-posta verilerinizi her gün otomatik olarak yedekler. Veri kaybı durumunda yedeklerden hızlıca geri yükleme yapılabilir.","Kurumsal e-posta ile Gmail veya Yandex Mail kullanabilir miyim?":"Hayır kullanamazsınız.","Kurumsal e-posta adresim ne kadar sürede aktif olur?":"Makdos, siparişinizin ardından <b>kurumsal e-posta</b> adresiniz gün içinde aktif hale getirilir.","Kaç kullanıcıya kadar e-posta adresi oluşturabilirim?":"Makdos, kullanıcı sayısını işletmenizin ihtiyacına göre belirlemenize olanak tanır. Sınırsız kullanıcı desteğiyle esneklik sağlar.","Makdos Kurumsal Mail Hosting güvenli midir?":"Evet, gelişmiş güvenlik protokollerimiz sayesinde e-posta trafiğiniz DDoS ve veri hırsızlığı gibi tehditlere karşı korunur.","Web mail üzerinden nasıl giriş yapabilirim?":"Makdos <b>web mail</b> hizmeti, kullanıcı dostu bir arayüz sunar. Alan adınıza özel giriş bilgileriyle her cihazdan erişim sağlayabilirsiniz.","E-postalarım ne kadar süreyle saklanır?":"Makdos, e-postalarınızı güvenli sunucularında uzun süre saklar. İhtiyacınıza göre depolama seçeneklerini özelleştirebilirsiniz.","Kurumsal e-posta maliyeti nedir?":"Makdos, işletmenizin ihtiyaçlarına göre farklı fiyatlandırma seçenekleri sunar. Kullanıcı sayısı, disk alanı ve ek hizmetlere bağlı olarak paketlerimizi inceleyebilirsiniz.","Makdos e-posta yönetim paneli nasıl kullanılır?":"Kullanıcı dostu arayüzümüz sayesinde, mail adreslerinizi kolayca oluşturabilir, yönlendirme yapabilir ve spam ayarlarını düzenleyebilirsiniz.","Makdos Mail Hosting yedekleme hizmeti ücretli mi?":"Hayır, günlük yedekleme hizmeti Makdos’un tüm <b>mail hosting</b> paketlerinde ücretsiz olarak sunulur.","Makdos kurumsal e-posta hizmetini neden tercih etmeliyim?":"Makdos, güvenilir altyapısı, gelişmiş güvenlik önlemleri, günlük yedekleme ve esnek paket seçenekleriyle işletmelere profesyonel çözümler sunar.","E-posta hizmetim kesintiye uğrar mı?":"Makdos %99,8 uptime garantisi sunarak e-posta hizmetinizin kesintisiz çalışmasını sağlar.","Otomatik cevap ayarlarını nasıl yapabilirim?":"Makdos paneli üzerinden birkaç adımda otomatik cevap ayarlarınızı yapabilir ve müşterilerinize her zaman yanıt verebilirsiniz.","Kurumsal e-posta için teknik destek alabilir miyim?":"Evet, Makdos’un 7/24 erişilebilir teknik destek ekibi tüm sorularınızı yanıtlamak için her zaman yanınızdadır."}');
;// CONCATENATED MODULE: ./public/SSS/sss-en-kurumsal-eposta.json
var sss_en_kurumsal_eposta_namespaceObject = JSON.parse('{"On which devices can I use my e-mail account?":"You can use your <b>corporate e-mail</b> account on all devices such as computers, smartphones and tablets.","How can I change the username and password of my e-mail account?":"You can change your username and password by logging into your e-mail account from the customer panel.","Can I send bulk e-mails?":"Yes, you can send bulk e-mails to deliver your business news, campaigns and announcements to your customers. However, this should not exceed your bulk mail hourly sending limit.","How can I use corporate emails from mobile devices?":"Our <b>corporate email</b> service is compatible with all popular mobile devices. By configuring your email settings for Android and iOS devices, you can access and manage your emails from your mobile device.","What is the difference between Makdos Corporate E-Mail and personal e-mail services?":"Personal e-mail services (such as Gmail, Yandex Mail) are ideal for personal use. However, Makdos <b>Corporate Mail Hosting</b> offers businesses a custom domain name, advanced security, daily backups and customizable features.","Does the corporate e-mail service have spam protection?":"Yes, Makdos <b>Mail Hosting</b> protects your e-mails from spam with advanced spam filtering technology.","How can I get my corporate e-mail address?":"You can create your <b>corporate e-mail</b> address specific to your domain name with a few easy steps via Makdos. You can get an e-mail address by clicking the “Configure” button in Makdos Mail service.","Can I forward my emails to another address?":"Yes, you can easily forward your incoming e-mails to another e-mail address with Makdos Mail Management Panel.","Which protocols does Makdos Mail Hosting support?":"Makdos supports IMAP, SMTP and POP3 protocols, making it easy to access e-mail from all devices.","Does Makdos Mail Hosting have daily backups?":"Yes, Makdos automatically backs up all your e-mail data every day. In case of data loss, you can quickly restore from backups.","Can I use Gmail or Yandex Mail with my corporate e-mail?":"No, you cannot.","How long does it take to activate my corporate e-mail address?":"Makdos, your <b>corporate e-mail</b> address will be activated within the day after your order.","How many users can I create email addresses for?":"Makdos allows you to determine the number of users according to the needs of your business. It provides flexibility with unlimited user support.","Is Makdos Corporate Mail Hosting secure?":"Yes, with our advanced security protocols, your e-mail traffic is protected against threats such as DDoS and data theft.","How can I log in via web mail?":"Makdos <b>web mail</b> service offers a user-friendly interface. You can access from any device with login information specific to your domain name.","How long are my emails stored?":"Makdos stores your emails on its secure servers for a long time. You can customize storage options according to your needs.","How much does corporate email cost?":"Makdos offers different pricing options according to the needs of your business. You can review our packages depending on the number of users, disk space and additional services.","How to use Makdos E-mail Management Panel?":"With our user-friendly interface, you can easily create your e-mail addresses, forward and edit spam settings.","Is Makdos Mail Hosting backup service paid?":"No, daily backup service is offered free of charge in all <b>mail hosting</b> packages of Makdos.","Why should I choose Makdos corporate e-mail service?":"Makdos offers professional solutions to businesses with its reliable infrastructure, advanced security measures, daily backup and flexible package options.","Will my e-mail service be interrupted?":"Makdos offers a 99.8% uptime guarantee to ensure uninterrupted operation of your e-mail service.","How can I set automatic reply settings?":"You can set your auto reply settings in a few steps via Makdos panel and you can always respond to your customers.","Can I get technical support for corporate email?":"Yes, Makdos\' 24/7 technical support team is always available to answer all your questions."}');
// EXTERNAL MODULE: ./helpers/googleEvents.js
var googleEvents = __webpack_require__(41804);
// EXTERNAL MODULE: ./components/PhysicalServers/DidntFindForm.js
var DidntFindForm = __webpack_require__(11883);
;// CONCATENATED MODULE: ./components/CorporateEmail/WhatIsCorporateEmail.js




var WhatIsCorporateEmail = function() {
    var t = (0,esm/* useTranslation */.$G)([
        "common",
        "homepage",
        "email"
    ]).t;
    (0,react.useEffect)(function() {
        var handleScroll = function() {
            var targetElement = document.querySelector(".animate-on-scroll");
            if (targetElement) {
                var rect = targetElement.getBoundingClientRect();
                var isInViewport = rect.top < window.innerHeight && rect.bottom >= 0;
                if (isInViewport) {
                    targetElement.classList.add("visible");
                }
            }
        };
        window.addEventListener("scroll", handleScroll);
        return function() {
            return window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "container py-10 mx-auto lg:py-20",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "pb-10 lg:pb-0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "relative px-2 pt-8 pb-4 text-3xl font-semibold text-titleColor lg:text-center lg:text-4xl text-after-shadow-email3",
                        children: t("email:whatIsCorporateEmail")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mx-2 text-sm text-textGray lg:text-base lg:text-center lg:pb-20",
                        dangerouslySetInnerHTML: {
                            __html: t("email:whatIsCorporateEmailDesc")
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid px-2 mx-auto lg:grid-cols-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative hidden lg:block",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute z-10 animate-on-scroll",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: "/whatIsCorporateEmail2.svg",
                                    width: 401,
                                    height: 489,
                                    alt: t("email:whatIsCorporateEmail"),
                                    title: t("email:whatIsCorporateEmail")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: "/whatIsCorporateEmail1.svg",
                                    width: 340,
                                    height: 618,
                                    alt: t("email:whatIsCorporateEmail"),
                                    title: t("email:whatIsCorporateEmail")
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "block pb-10 lg:hidden lg:pb-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/whatIsCorporateEmail.svg",
                            width: 479,
                            height: 618,
                            alt: t("email:whatIsCorporateEmail"),
                            title: t("email:whatIsCorporateEmail")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "space-y-6 lg:space-y-12",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "space-y-2.5 ",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "text-3xl font-bold text-titleColor",
                                        children: t("email:corporateEmailAdvantages")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-sm font-medium text-textGray lg:text-base",
                                        dangerouslySetInnerHTML: {
                                            __html: t("email:corporateEmailAdvantagesDesc")
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        className: "text-lg font-bold text-titleColor",
                                        children: t("email:secureCommunication")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-sm font-medium text-textGray lg:text-base",
                                        children: t("email:secureCommunicationDesc")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        className: "text-lg font-bold text-titleColor",
                                        children: t("email:backupAndDataProtection")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-sm font-medium text-textGray lg:text-base",
                                        children: t("email:backupAndDataProtectionDesc")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        className: "text-lg font-bold text-titleColor",
                                        children: t("email:customizableStructure")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-sm font-medium text-textGray lg:text-base",
                                        children: t("email:customizableStructureDesc")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        className: "text-lg font-bold text-titleColor",
                                        children: t("email:uninterruptedAccess")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-sm font-medium text-textGray lg:text-base",
                                        children: t("email:uninterruptedAccessDesc")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        className: "text-lg font-bold text-titleColor",
                                        children: t("email:professionalImage")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-sm font-medium text-textGray lg:text-base",
                                        children: t("email:professionalImageDesc")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-sm font-medium text-textGray lg:text-base",
                                dangerouslySetInnerHTML: {
                                    __html: t("email:corporateEmailAdvantagesDesc2")
                                }
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var CorporateEmail_WhatIsCorporateEmail = (WhatIsCorporateEmail);

;// CONCATENATED MODULE: ./components/CorporateEmail/EasyAndFastMailManagement.js




var EasyAndFastMailManagement = function() {
    var t = (0,esm/* useTranslation */.$G)([
        "common",
        "homepage",
        "email"
    ]).t;
    var ref = (0,react.useState)(0), currentIndex = ref[0], setCurrentIndex = ref[1];
    var sliderData = [
        {
            title: t("email:userManagement"),
            description: t("email:userManagementDesc")
        },
        {
            title: t("email:storageManagement"),
            description: t("email:storageManagementDesc")
        },
        {
            title: t("email:spamAndSecuritySettings"),
            description: t("email:spamAndSecuritySettingsDesc")
        },
        {
            title: t("email:emailForwarding"),
            description: t("email:emailForwardingDesc")
        },
        {
            title: t("email:automaticReplies"),
            description: t("email:automaticRepliesDesc")
        },
        {
            title: t("email:backupAndRecovery"),
            description: t("email:backupAndRecoveryDesc")
        },
        {
            title: t("email:performanceMonitoring"),
            description: t("email:performanceMonitoringDesc")
        }, 
    ];
    (0,react.useEffect)(function() {
        var interval = setInterval(function() {
            setCurrentIndex(function(prevIndex) {
                return (prevIndex + 1) % sliderData.length;
            });
        }, 4000);
        return function() {
            return clearInterval(interval);
        };
    }, [
        currentIndex,
        sliderData.length
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "container py-5 mx-auto lg:py-20",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "grid px-2 lg:mx-auto lg:items-center lg:grid-cols-2",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "pb-4 text-lg text-titleColor",
                                    children: t("email:mailManagementPanel")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "pb-6 text-3xl font-bold text-titleColor lg:text-4xl",
                                    children: t("email:easyAndFastMailManagement")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "pb-6 text-sm text-textGray lg:text-base",
                                    dangerouslySetInnerHTML: {
                                        __html: t("email:easyAndFastMailManagementDesc")
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                className: "pb-8 text-base font-bold lg:text-xl text-titleColor",
                                children: [
                                    t("email:introductionOfPanelFeatures"),
                                    ":"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "relative h-[120px] lg:h-[150px] overflow-hidden",
                            children: sliderData.map(function(item, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "absolute inset-0 transition-opacity duration-300 ease-in-out ".concat(index === currentIndex ? "opacity-100" : "opacity-0"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                            className: "pb-2 text-base font-bold lg:text-lg text-titleColor",
                                            children: item.title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-sm font-medium text-textGray lg:text-base",
                                            dangerouslySetInnerHTML: {
                                                __html: item.description
                                            }
                                        })
                                    ]
                                }, index);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex gap-5 mt-4",
                            children: sliderData.map(function(_, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-10 lg:w-20 h-2 lg:h-2.5 rounded-full bg-makdosDarkPurple relative overflow-hidden cursor-pointer",
                                    onClick: function() {
                                        return setCurrentIndex(index);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "absolute top-0 left-0 h-full bg-makdosYellow ".concat(index === currentIndex ? "transition-all duration-[4s] w-full" : "w-0")
                                    })
                                }, index);
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "pt-10 lg:pt-0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: "/EasyAndFastMailManagement.svg",
                        width: 564,
                        height: 518,
                        alt: t("email:easyAndFastMailManagement"),
                        title: t("email:easyAndFastMailManagement")
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var CorporateEmail_EasyAndFastMailManagement = (EasyAndFastMailManagement);

;// CONCATENATED MODULE: ./components/CorporateEmail/EasyManagementAndUserAddingAdvantages.js



var EasyManagementAndUserAddingAdvantages = function() {
    var t = (0,esm/* useTranslation */.$G)([
        "common",
        "homepage",
        "email"
    ]).t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "container py-10 mx-auto lg:py-20",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "grid mx-auto lg:grid-cols-2",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "order-2 pt-4 lg:order-1 lg:pt-0 ",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: "/easyManagementAndUserAddingAdvantages.svg",
                        width: 632,
                        height: 474,
                        alt: t("email:easyManagementAndUserAddingAdvantages"),
                        title: t("email:easyManagementAndUserAddingAdvantages")
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "order-1 px-2 lg:px-0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "pb-6 text-3xl font-bold text-titleColor lg:text-4xl",
                            children: t("email:easyManagementAndUserAddingAdvantages")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "space-y-5",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: "text-xl font-bold text-titleColor",
                                            children: t("email:quickAccess")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-sm font-medium text-textGray lg:text-base",
                                            children: t("email:quickAccessDesc")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: "text-xl font-bold text-titleColor",
                                            children: t("email:savingTime")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-sm font-medium text-textGray lg:text-base",
                                            children: t("email:savingTimeDesc")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: "text-xl font-bold text-titleColor",
                                            children: t("email:flexibility")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-sm font-medium text-textGray lg:text-base",
                                            children: t("email:flexibilityDesc")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: "text-xl font-bold text-titleColor",
                                            children: t("email:simpleUsage")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-sm font-medium text-textGray lg:text-base",
                                            children: t("email:simpleUsageDesc")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: "text-xl font-bold text-titleColor",
                                            children: t("email:easeOfRoutingAndResponse")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-sm font-medium text-textGray lg:text-base",
                                            dangerouslySetInnerHTML: {
                                                __html: t("email:easeOfRoutingAndResponseDesc")
                                            }
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var CorporateEmail_EasyManagementAndUserAddingAdvantages = (EasyManagementAndUserAddingAdvantages);

;// CONCATENATED MODULE: ./components/CorporateEmail/FastInstallationAnd247TechnicalSupport.js



var FastInstallationAnd247TechnicalSupport = function() {
    var t = (0,esm/* useTranslation */.$G)([
        "common",
        "homepage",
        "email"
    ]).t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "py-10 bg-makdosSecondaryGray",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container mx-auto",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "relative z-10 px-2 text-3xl font-semibold text-center text-titleColor lg:px-0 lg:text-4xl text-after-shadow-email4",
                        children: t("email:fastInstallationAnd247TechnicalSupport")
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col items-center px-2 mt-8 lg:flex-row lg:px-0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "p-4 bg-white border-4 border-makdosYellow w-full lg:w-[297px] h-[380px] lg:h-[600px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: "pb-2 text-2xl font-semibold text-titleColor",
                                            children: t("email:quickAndEasyInstallationProcess")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "pb-6 text-sm text-textGray lg:text-base",
                                            dangerouslySetInnerHTML: {
                                                __html: t("email:quickAndEasyInstallationProcessDesc")
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "pb-6",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                            className: "font-bold text-titleColor",
                                            children: t("email:userFriendlyPanel")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-sm text-textGray lg:text-base",
                                            children: t("email:userFriendlyPanelDesc")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "pb-6",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                            className: "font-bold text-titleColor",
                                            children: t("email:quickActivation")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-sm text-textGray lg:text-base",
                                            dangerouslySetInnerHTML: {
                                                __html: t("email:quickActivationDesc")
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "pb-6",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                            className: "font-bold text-titleColor",
                                            children: t("email:guidedInstallationSupport")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-sm text-textGray lg:text-base",
                                            children: t("email:guidedInstallationSupportDesc")
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "pt-4 lg:pt-0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: "/fastInstallation247TechnicalSupport.png",
                                width: 617,
                                height: 600,
                                alt: t("email:fastInstallationAnd247TechnicalSupport"),
                                title: t("email:fastInstallationAnd247TechnicalSupport")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "p-4 bg-white border-4 border-makdosYellow w-full lg:w-[297px] h-[480px] lg:h-[600px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "pb-6 space-y-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: "text-2xl font-semibold text-titleColor",
                                            children: t("email:247TechnicalSupportTeam")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-sm text-textGray lg:text-base",
                                            children: t("email:247TechnicalSupportTeamDesc")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "pb-6",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                                            className: "font-bold text-titleColor",
                                            children: [
                                                t("email:quickSolution"),
                                                ":"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-sm text-textGray lg:text-base",
                                            children: t("email:quickSolutionDesc")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "pb-6",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                                            className: "font-bold text-titleColor",
                                            children: [
                                                t("email:variousSupportChannels"),
                                                ":"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-sm text-textGray lg:text-base",
                                            dangerouslySetInnerHTML: {
                                                __html: t("email:variousSupportChannelsDesc")
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "pb-6",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                                            className: "font-bold text-titleColor",
                                            children: [
                                                t("email:proactiveSupport"),
                                                ":"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-sm text-textGray lg:text-base",
                                            dangerouslySetInnerHTML: {
                                                __html: t("email:proactiveSupportDesc")
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "pb-2 ",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                                            className: "font-bold text-titleColor",
                                            children: [
                                                t("email:expertStaff"),
                                                ":"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-sm text-textGray lg:text-base",
                                            children: t("email:expertStaffDesc")
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var CorporateEmail_FastInstallationAnd247TechnicalSupport = (FastInstallationAnd247TechnicalSupport);

;// CONCATENATED MODULE: ./components/CorporateEmail/UninterruptedSupportWithMakdos.js



var UninterruptedSupportWithMakdos = function() {
    var t = (0,esm/* useTranslation */.$G)([
        "common",
        "homepage",
        "email"
    ]).t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "container mx-auto",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "grid items-center gap-5 py-12 lg:grid-cols-2",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "order-2 lg:order-1",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: "/UninterruptedSupportWithMakdos.svg",
                        width: 538,
                        height: 431,
                        alt: t("email:uninterruptedSupportWithMakdos"),
                        title: t("email:uninterruptedSupportWithMakdos")
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "order-1 px-2 lg:order-2 lg:px-0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "pb-6 text-3xl font-bold text-titleColor lg:text-4xl",
                            children: t("email:uninterruptedSupportWithMakdos")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "pb-4 text-sm text-textGray lg:text-base",
                            dangerouslySetInnerHTML: {
                                __html: t("email:uninterruptedSupportWithMakdosDesc1")
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "pb-4 text-sm text-textGray lg:text-base",
                            children: t("email:uninterruptedSupportWithMakdosDesc2")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-sm font-bold text-textGray lg:text-base",
                            children: t("email:uninterruptedSupportWithMakdosDesc3")
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var CorporateEmail_UninterruptedSupportWithMakdos = (UninterruptedSupportWithMakdos);

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(72006);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(4405);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-table@7.8.0_react@18.2.0/node_modules/react-table/index.js
var react_table = __webpack_require__(86716);
;// CONCATENATED MODULE: ./components/CorporateEmail/CorporateEmailTable.js






var CorporateEmailTable = function(param) {
    var data = param.data;
    var t = (0,esm/* useTranslation */.$G)([
        "common",
        "email"
    ]).t;
    var columns = (0,react.useMemo)(function() {
        return [
            {
                Header: t("email:features"),
                accessor: "properties"
            },
            {
                Header: "Yandex Mail",
                accessor: "yandexmail"
            },
            {
                Header: "Gmail",
                accessor: "gmail"
            },
            {
                Header: "Makdos",
                accessor: "makdos"
            }
        ];
    }, []);
    var ref = (0,react_table.useTable)({
        columns: columns,
        data: data
    }), getTableProps = ref.getTableProps, getTableBodyProps = ref.getTableBodyProps, headerGroups = ref.headerGroups, rows = ref.rows, prepareRow = ref.prepareRow;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getTableProps()), {
        className: "w-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                children: headerGroups.map(function(headerGroup) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, headerGroup.getHeaderGroupProps()), {
                        children: headerGroup.headers.map(function(column) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("th", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, column.getHeaderProps()), {
                                className: "p-3 text-sm text-left bg-makdosTitleDiv text-textWhite whitespace-nowrap",
                                children: column.render("Header")
                            }));
                        })
                    }));
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getTableBodyProps()), {
                children: rows.map(function(row, index) {
                    prepareRow(row);
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, row.getRowProps()), {
                        className: index % 2 === 0 ? " bg-white p-3" : " bg-makdosSecondaryGray p-3",
                        children: row.cells.map(function(cell) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("td", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cell.getCellProps()), {
                                className: "p-3 whitespace-nowrap",
                                children: cell.render("Cell")
                            }));
                        })
                    }));
                })
            }))
        ]
    }));
};
/* harmony default export */ var CorporateEmail_CorporateEmailTable = (CorporateEmailTable);

;// CONCATENATED MODULE: ./components/CorporateEmail/ProfessionalAlternativeMakdosMailHosting.js




var ProfessionalAlternativeMakdosMailHosting = function() {
    var t = (0,esm/* useTranslation */.$G)([
        "common",
        "homepage",
        "email"
    ]).t;
    var data = [
        {
            properties: t("email:customDomainNameUsage"),
            yandexmail: t("email:yes"),
            gmail: t("email:yes"),
            makdos: t("email:yes")
        },
        {
            properties: t("email:dailyBackup"),
            yandexmail: t("email:no"),
            gmail: t("email:no"),
            makdos: t("email:yes")
        },
        {
            properties: t("email:spamProtection"),
            yandexmail: t("email:middle"),
            gmail: t("email:middle"),
            makdos: t("email:developed")
        },
        {
            properties: t("email:price"),
            yandexmail: t("email:high"),
            gmail: t("email:high"),
            makdos: t("email:suitable")
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "container mx-auto my-6 lg:my-12",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "relative px-2 text-3xl font-bold text-titleColor lg:px-0 lg:text-center lg:text-4xl text-after-shadow-email",
                        children: t("email:professionalAlternativeToGmailAndYandexMail")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "relative px-2 text-3xl font-bold lg:text-center text-titleColor lg:px-0 lg:text-4xl text-after-shadow-email2",
                        children: t("email:makdosMailHosting")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "px-2 py-8 text-sm text-textGray lg:text-xl lg:px-0",
                        dangerouslySetInnerHTML: {
                            __html: t("email:professionalAlternativeToGmailAndYandexMailDesc")
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col items-center space-x-3 space-y-5 lg:pt-6 lg:space-y-0 lg:flex-row",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: "/ProfessionalAlternativeMakdosMailHosting.svg",
                        width: 232,
                        height: 261,
                        alt: t("email:makdosMailHosting"),
                        title: t("email:makdosMailHosting")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full overflow-x-auto",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CorporateEmail_CorporateEmailTable, {
                            data: data
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var CorporateEmail_ProfessionalAlternativeMakdosMailHosting = (ProfessionalAlternativeMakdosMailHosting);

;// CONCATENATED MODULE: ./pages/email/mail.js
























function corporateemail(param) {
    var datas = param.datas, rates = param.rates;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
    var t = (0,esm/* useTranslation */.$G)([
        "common",
        "email"
    ]).t;
    var ref12 = (0,react.useState)([]), mailServerList = ref12[0], setMailServerList = ref12[1];
    var ref13 = (0,_sliced_to_array/* default */.Z)((0,GlobalStore/* useGlobalStore */.s)(function(state) {
        return [
            state.setCurrencyRates,
            state.currencyRates,
            state.currencyType
        ];
    }), 3), setCurrencyRates = ref13[0], currencyRates = ref13[1], currencyType = ref13[2];
    var ref14 = (0,_sliced_to_array/* default */.Z)((0,ConfigurationStore/* useConfigurationStore */.w)(function(state) {
        return [
            state.setSelectedServer,
            state.clearAllConfigurations,
            state.setConfigurationType
        ];
    }), 3), setSelectedServer = ref14[0], clearAllConfigurations = ref14[1], setConfigurationType = ref14[2];
    var router = (0,next_router.useRouter)();
    var onGetMailServerList = function() {
        setMailServerList(datas);
    };
    var calculatePrice = function(p) {
        var newPrice = (0,helpersFunc/* changeCurrency */.sy)(currencyRates, currencyType, parseFloat(p === null || p === void 0 ? void 0 : p.toFixed(2)));
        var price = newPrice;
        var splitedPrice = price.split(".");
        return splitedPrice;
    };
    var goConfigurations = function(id) {
        clearAllConfigurations();
        (0,googleEvents/* googleEventConfiguration */.Cg)(mailServerList[0], mailServerList[0].one_month_price, mailServerList[0].currency, "product_page");
        setSelectedServer(id);
        setConfigurationType("mail");
        router.push(t("nav:configuration"));
    };
    (0,react.useEffect)(function() {
        onGetMailServerList();
    }, []);
    (0,react.useEffect)(function() {
        setCurrencyRates(rates);
    }, [
        rates
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: t("emailMetaTitle")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: t("emailMetaDescription")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: t("emailMetaTitle")
                    }, "title"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: t("emailMetaDescription")
                    }, "description")
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-full",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bg-no-repeat bg-emailBg",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "container px-4 pt-20 pb-20 mx-auto lg:px-0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-center justify-between mb-14",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "text-xl",
                                                    children: t("email:title")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                    className: "my-3 text-5xl font-semibold",
                                                    children: t("email:title2")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "lg:w-[800px]",
                                                    dangerouslySetInnerHTML: {
                                                        __html: t("email:description")
                                                    }
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "hidden lg:flex",
                                            children: router.locale === "tr" ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: "/corparateEmail.svg",
                                                alt: "email",
                                                title: "E-Mail",
                                                width: "313",
                                                height: "110",
                                                priority: true,
                                                loading: "eager",
                                                className: "transform-gpu"
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: "/corparateEmailEN.svg",
                                                alt: "email",
                                                title: "E-Mail",
                                                width: "313",
                                                height: "110",
                                                priority: true,
                                                loading: "eager",
                                                className: "transform-gpu"
                                            })
                                        })
                                    ]
                                }),
                                mailServerList && mailServerList.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "grid grid-cols-2 gap-8",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "col-span-2 p-5 bg-white rounded-md shadow-md lg:col-span-1",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "text-3xl font-semibold",
                                                    children: (ref = mailServerList[0]) === null || ref === void 0 ? void 0 : ref.product_name
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "grid grid-cols-3 gap-6 mt-6 lg:grid-cols-4",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "col-span-1",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "emailSize",
                                                                    children: t("e-mail")
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                    className: "text-lg font-semibold lg:text-2xl",
                                                                    children: [
                                                                        (ref1 = mailServerList[0]) === null || ref1 === void 0 ? void 0 : ref1.email_number,
                                                                        " ",
                                                                        t("unit")
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "col-span-1",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "temailSize",
                                                                    children: "Firewall"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "text-lg font-semibold lg:text-2xl",
                                                                    children: ((ref2 = mailServerList[0]) === null || ref2 === void 0 ? void 0 : ref2.has_firewall) ? t("available") : t("not-available")
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "col-span-1",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "emailSize",
                                                                    children: "Disk"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "text-lg font-semibold lg:text-2xl",
                                                                    children: ((ref3 = mailServerList[0]) === null || ref3 === void 0 ? void 0 : ref3.disk.disk_size) + " " + ((ref4 = mailServerList[0]) === null || ref4 === void 0 ? void 0 : ref4.disk.disk_unit)
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "hidden lg:block"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "col-span-1",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "emailSize",
                                                                    children: t("spam-filter")
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "text-lg font-semibold lg:text-2xl",
                                                                    children: ((ref5 = mailServerList[0]) === null || ref5 === void 0 ? void 0 : ref5.has_spam_filter) ? t("available") : t("not-available")
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "col-span-1",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "emailSize",
                                                                    children: "Backup"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "text-lg font-semibold lg:text-2xl",
                                                                    children: router.locale === "tr" ? (ref6 = mailServerList[0]) === null || ref6 === void 0 ? void 0 : ref6.backup : "Daily"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "col-span-1",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "emailSize",
                                                                    children: "IP"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "text-lg font-semibold lg:text-2xl",
                                                                    children: ((ref7 = mailServerList[0]) === null || ref7 === void 0 ? void 0 : ref7.ip_address) === "/32" ? "1 " + t("unit") : (ref8 = mailServerList[0]) === null || ref8 === void 0 ? void 0 : ref8.ip_address
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex items-center justify-between p-3 mt-3 rounded-md bg-[#F1F5F9]",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "flex items-center",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "flex",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                            className: "text-3xl font-semibold text-titleColor",
                                                                            children: [
                                                                                calculatePrice((ref9 = mailServerList[0]) === null || ref9 === void 0 ? void 0 : ref9.one_month_price)[0],
                                                                                "."
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "flex flex-col ml-1",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                    className: "p-0 m-0 text-sm font-semibold text-titleColor",
                                                                                    children: [
                                                                                        calculatePrice((ref10 = mailServerList[0]) === null || ref10 === void 0 ? void 0 : ref10.one_month_price)[1],
                                                                                        " ",
                                                                                        currencyType
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                    className: "p-0 m-0 text-xs text-titleColor",
                                                                                    children: [
                                                                                        t("common:monthly"),
                                                                                        " + ",
                                                                                        t("extra")
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                    className: "ml-4",
                                                                    children: [
                                                                        " ",
                                                                        t("startingPrice")
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                            onClick: function() {
                                                                var ref;
                                                                return goConfigurations((ref = mailServerList[0]) === null || ref === void 0 ? void 0 : ref.id);
                                                            },
                                                            name: (ref11 = mailServerList[0]) === null || ref11 === void 0 ? void 0 : ref11.id,
                                                            buttonText: t("common:configure"),
                                                            buttonLeftIcon: "ri-tools-fill"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "z-10 grid col-span-2 p-5 overflow-hidden bg-white rounded-md shadow-md lg:grid-cols-5 lg:relative lg:col-span-1",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex flex-col justify-center lg:col-span-3",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "text-2xl font-semibold text-makdosTitleDiv",
                                                            children: t("email:boxHeading")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "mt-3 text-cardText",
                                                            children: t("email:boxParagraph")
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "ml-5 lg:ml-0 lg:col-span-2 lg:absolute lg:-right-2 lg:-bottom-1",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: "/kurumsal-email.svg",
                                                        alt: "mailbox",
                                                        title: "mailbox",
                                                        width: "270",
                                                        height: "270"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "grid grid-cols-2 mt-20 lg:gap-6",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-span-2 lg:col-span-1",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: "/emailImage.png",
                                                alt: "email",
                                                title: "Email",
                                                width: "628",
                                                height: "392"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex items-center col-span-2 lg:col-span-1",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex flex-col justify-center pr-9",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                        className: "mb-1 text-4xl font-semibold text-titleColor",
                                                        children: t("email:paragraphTitle")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                        className: "mb-5 text-4xl font-semibold text-titleColor",
                                                        children: t("email:paragraphTitle2")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "text-sm text-textGray",
                                                        dangerouslySetInnerHTML: {
                                                            __html: t("email:paragraph")
                                                        }
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CorporateEmail_EmailServices, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CorporateEmail_WhatIsCorporateEmail, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CorporateEmail_EasyAndFastMailManagement, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CorporateEmail_EasyManagementAndUserAddingAdvantages, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CorporateEmail_FastInstallationAnd247TechnicalSupport, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CorporateEmail_ProfessionalAlternativeMakdosMailHosting, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CorporateEmail_UninterruptedSupportWithMakdos, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-20",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SSS/* default */.Z, {
                    data: router.locale === "tr" ? sss_tr_kurumsal_eposta_namespaceObject : sss_en_kurumsal_eposta_namespaceObject
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DidntFindForm/* default */.Z, {
                eposta: true
            })
        ]
    });
}
var __N_SSP = true;
/* harmony default export */ var mail = (corporateemail);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2658,6716,4967,1804,1736,9774,2888,179], function() { return __webpack_exec__(30550); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);